/**
 * Debug logger utility with timestamps for diagnosing timing issues.
 * Timestamps are shown as [HH:MM:SS.mmm] for easy log analysis.
 */

/**
 * Gets a formatted timestamp string for logging
 * @returns Timestamp in format [HH:MM:SS.mmm]
 */
export const getTimestamp = (): string => {
  const now = new Date()
  const hours = now.getHours().toString().padStart(2, '0')
  const minutes = now.getMinutes().toString().padStart(2, '0')
  const seconds = now.getSeconds().toString().padStart(2, '0')
  const ms = now.getMilliseconds().toString().padStart(3, '0')
  return `[${hours}:${minutes}:${seconds}.${ms}]`
}

/**
 * Debug logger with automatic timestamp prefixing
 */
export const debugLog = {
  /**
   * Logs a message with timestamp
   * @param prefix - The log prefix (e.g., '🚀 [sendMessage]')
   * @param message - The message to log
   * @param data - Optional data to log
   */
  log: (prefix: string, message: string, data?: unknown) => {
    if (data !== undefined) {
      console.log(`${getTimestamp()} ${prefix} ${message}`, data)
    } else {
      console.log(`${getTimestamp()} ${prefix} ${message}`)
    }
  },

  /**
   * Logs an error with timestamp
   */
  error: (prefix: string, message: string, data?: unknown) => {
    if (data !== undefined) {
      console.error(`${getTimestamp()} ${prefix} ${message}`, data)
    } else {
      console.error(`${getTimestamp()} ${prefix} ${message}`)
    }
  },

  /**
   * Logs a separator line with timestamp
   */
  separator: () => {
    console.log(
      `${getTimestamp()} ═══════════════════════════════════════════════════════════`,
    )
  },
}
